// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconLegend_icon__2hUGF","bg":"IconLegend_bg__1TB3P"};